var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 3.75H4.6875C4.63777 3.75 4.59008 3.76975 4.55492 3.80492C4.51975 3.84008 4.5 3.88777 4.5 3.9375V5.25H0.75V1.5H2.4375C2.48723 1.5 2.53492 1.48025 2.57008 1.44508C2.60525 1.40992 2.625 1.36223 2.625 1.3125V0.9375C2.625 0.887772 2.60525 0.840081 2.57008 0.804918C2.53492 0.769754 2.48723 0.75 2.4375 0.75H0.5625C0.413316 0.75 0.270242 0.809263 0.164752 0.914752C0.0592632 1.02024 0 1.16332 0 1.3125L0 5.4375C0 5.58668 0.0592632 5.72976 0.164752 5.83525C0.270242 5.94074 0.413316 6 0.5625 6H4.6875C4.83668 6 4.97976 5.94074 5.08525 5.83525C5.19074 5.72976 5.25 5.58668 5.25 5.4375V3.9375C5.25 3.88777 5.23025 3.84008 5.19508 3.80492C5.15992 3.76975 5.11223 3.75 5.0625 3.75ZM5.71875 0H4.21875C3.96832 0 3.84316 0.303633 4.01953 0.480469L4.43824 0.89918L1.58203 3.75434C1.55581 3.78046 1.53501 3.81151 1.52081 3.8457C1.50662 3.87989 1.49931 3.91654 1.49931 3.95355C1.49931 3.99057 1.50662 4.02722 1.52081 4.06141C1.53501 4.0956 1.55581 4.12664 1.58203 4.15277L1.8477 4.41797C1.87382 4.44419 1.90487 4.46499 1.93906 4.47919C1.97325 4.49338 2.0099 4.50069 2.04691 4.50069C2.08393 4.50069 2.12058 4.49338 2.15477 4.47919C2.18896 4.46499 2.22 4.44419 2.24613 4.41797L5.10094 1.56234L5.51953 1.98047C5.69531 2.15625 6 2.0332 6 1.78125V0.28125C6 0.206658 5.97037 0.135121 5.91762 0.0823762C5.86488 0.0296316 5.79334 0 5.71875 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkAlt);
export default __webpack_public_path__ + "static/media/external-link-alt.c9b637005191642fde10806bca883861.svg";
export { ForwardRef as ReactComponent };